// @flow
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import axios from "axios";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../components/mui/app/pageTitle/pageTitle";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { API } from "../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../helpers/errorHandling";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import useUserAction from "../../hooks/user/useUserAction";
import useUserData from "../../hooks/user/useUserData";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import {
	ROUTE_PAGE_QUESTIONNAIRE_PREVIEW,
	ROUTE_PAGE_QUESTIONNAIRE_PREVIEW_BY_HEADER
} from "../../modules/issues/routes/routes";


const UserQuestionnaire = () => {
	const { t } = useTranslation(CHECKLISTS)
	const history = useHistory()
	const { token, isLoggedIn, dateFormat } = useUserData()
	const { userLogout } = useUserAction()
	const [loading, setLoading] = useState(true)
	const [checklist, setChecklist] = useState(null)

	useEffect(() => {
		setLoading(true)
		axios({
			method: 'post',
			url: `${API}/en/custom/goodtohave/checklist`,
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
		}).then((res) => {
			const data = res.data?.data
			if (data && data.length > 0) {
				const item = data[0]
				const today = dayjs()
				const from = item.ucActiveFromDt ? dayjs(item.ucActiveFromDt) : null
				const to = item.ucActiveToDt ? dayjs(item.ucActiveToDt) : null
				const hasId = item.QuestionnaireId || item.HeaderId
				const isActive = from && to
					&& !today.isBefore(from, 'day')
					&& !today.isAfter(to, 'day')
					&& hasId
				if (isActive) {
					const url = parseInt(item.details) === 1
						? getRouteUrl(ROUTE_PAGE_QUESTIONNAIRE_PREVIEW_BY_HEADER, { headerId: item.HeaderId })
						: getRouteUrl(ROUTE_PAGE_QUESTIONNAIRE_PREVIEW, { questionnaireId: item.QuestionnaireId, headerId: item.HeaderId })
					history.replace(url)
					return
				}
				setChecklist(item)
			}
			setLoading(false)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			setLoading(false)
		})
	}, [token, isLoggedIn, t, history])

	const dateFrom = useMemo(() => (
		checklist?.ucActiveFromDt ? dayjs(checklist.ucActiveFromDt).format(dateFormat) : ''
	), [checklist, dateFormat])

	const dateTo = useMemo(() => (
		checklist?.ucActiveToDt ? dayjs(checklist.ucActiveToDt).format(dateFormat) : ''
	), [checklist, dateFormat])

	return (
		<SkeletonLoaderWrapper loading={loading}>
			<PageContentWrapper>
				<PageTitle title={t('questionnaire_form_message')} withDivider/>
				<Box
					display="flex"
					justifyContent="center"
					alignItems="center"
					mt={2}
					px={2}
				>
					<Alert severity="info" sx={{ maxWidth: 600, width: '100%' }}>
						<AlertTitle>
							{t('checklist_not_active', { dateFrom, dateTo })}
						</AlertTitle>
					</Alert>
				</Box>
			</PageContentWrapper>
		</SkeletonLoaderWrapper>
	)
}

export default UserQuestionnaire



